import React, { useState } from "react";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

/**
 * Composant qui permet d'afficher les accordions de l'ECP
 * @param {array} title - titre des accordions
 * @param {array} children - contenu des accordions
 */

export default function AccordionItem({ title, children }) {
    const [isOpen, setIsOpen] = useState(true);

    //Ouvrir ou fermer l'accordion
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion-item">
            <div className="accordion-title" onClick={toggleOpen}>
                <h2>{title}</h2>
                {isOpen ? <ExpandLess /> : <ExpandMore />}
            </div>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};